import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./routes.js";
import store from "./store/index.js";
import "@/assets/transitions.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faStar,
  faShoppingCart,
  faHeart,
  faBan,
  faCircleCheck,
  faChevronUp,
  faChevronDown,
  faPlus,
  faMinus,
  faTrash,
  faCheckCircle,
  faArrowRight,
  faArrowLeft,
  faHome
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Paginate from "vuejs-paginate";
import VueContentPlaceholders from "vue-content-placeholders";
import CripNotice from "crip-vue-notice";
Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueContentPlaceholders);
Vue.component("paginate", Paginate);

// Install component in to Vue instance.
Vue.use(CripNotice);

library.add(
  faUserSecret,
  faShoppingCart,
  faHeart,
  faStar,
  faBan,
  faCircleCheck,
  faChevronUp,
  faChevronDown,
  faPlus,
  faMinus,
  faTrash,
  faCheckCircle,
  faArrowRight,
  faArrowLeft,
  faHome
);

let app = document.getElementById("app");
let props = {
  view: app.getAttribute("data-view") || "home",
  offset: app.getAttribute("data-offset") || -300,
  productArr: app.getAttribute("data-product-ids"),
  categId: app.getAttribute("data-category-id"),
  defaultImage: app.getAttribute("data-default-image"),
  wizardCategories: app.getAttribute("data-wizard-categories"),
  initialScroll: app.getAttribute("data-initial-scroll"), 
  counter: 0,
};
const scrollProps = {
  yOffset: props.offset,
  element:  document.getElementById('app'),
}
scrollProps.y = scrollProps.element.getBoundingClientRect().top + window.pageYOffset + scrollProps.yOffset

Vue.component("font-awesome-icon", FontAwesomeIcon);

const router = new VueRouter({
  routes,
  scrollBehavior() {
    if (props.view !== 'category' && !props.initialScroll) {
      props.counter = 1;
    }
    if (props.counter > 1) {
      window.scrollTo({ top: scrollProps.y, behavior: 'smooth' });
    }
    props.counter++;
  }
});

Vue.prototype.shopSettings = props;

new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount("#app");
